import React from 'react'
import { NativeEvent } from '../../modules/types'
import { Select } from '../atoms'
import { SelectOption } from '../atoms/Select'
import './FormField.css'

type Props = {
  error?: string | boolean
  options: SelectOption[]
  placeholder: string
  className?: string
  title: string
  mandatory?: boolean
  onChange?: (e: NativeEvent) => void
  [key: string]: any
}


function FormFieldSelect(props: Props) {
  const { title, error, mandatory, onChange } = props

  function onChangeLocal(e: NativeEvent) {
    if (onChange) {
      onChange(e.currentTarget.value)
    }
  }

  return (
    <div>
      <div>
        <b className="form-title">{title}</b>
        {mandatory && (
          <span>*</span>
        )}
      </div>

      <Select 
        className="form-input"
        {...props}
        onChange={onChangeLocal} />

      {error && (
        <div className="form-error">
          <span>{error}</span>
        </div>
      )}
    </div>
  )
}

export default FormFieldSelect
